import script from "./InfantClubContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfantClubContent.vue?vue&type=script&setup=true&lang=ts"

import "./InfantClubContent.vue?vue&type=style&index=0&id=482c5bbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482c5bbe"]])

export default __exports__